export default "/images/my-giving-slider.svg?f8a6c7553d8abfaded8f5232e223f63b";